import React from 'react';
import styled from 'styled-components';
import { Switch } from 'tdesign-react';
import Tip from '@/components/Tip';

export default function TruncationAppend(props) {
  return (
    <Root>
      <Tip content='截断数据后只展示前1024字符的数据'>是否要截断数据</Tip>

      <Switch style={{ margin: '0 10px 0 8px' }} {...props} />
    </Root>
  );
}

const Root = styled.div`
  color: #202b40;
  font-size: 12px;
  font-style: normal;
  display: flex;
  align-items: center;
  height: 32px;
`;
